module.exports = new __parcel__URL__("blank.0c2912ca.svg").toString();